import React, {Component} from 'react'
import Error from './Error';

class ErrorBoundry extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    // Display fallback UI
    this.setState({ hasError: true });
   
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <Error/>;
    }
    return this.props.children;
  }
}

export default ErrorBoundry